import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Pages/Login/Login";
import ForgotPassword from "./Pages/ForgotPassword/ForgotPassword";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Patient from "./Pages/Patient/Patient";
import Laboratory from "./Pages/Laboratory/Laboratory";
import Billings from "./Pages/Billings/Billings";
import Appointments from "./Pages/Appointments/Appointments";
import MedicalRecords from "./Pages/MedicalRecords/MedicalRecords";
import Department from "./Pages/Department/Department";
import AddPatientPage from "./Pages/Patient/AddPatientPage";
import Doctors from "./Pages/Doctors/Doctors";
import Nurses from "./Pages/Nurses/Nurses";
import AddDoctor from "./Pages/Doctors/AddDoctor";
import AddNurse from "./Pages/Nurses/AddNurse";
import Nursing from "./Pages/Nursing/Nursing";
import Staff from "./Pages/Staff/Staff";
import AddStaff from "./Pages/Staff/AddStaff";
import Reception from "./Pages/Reception/Reception";
import RolesPermissions from "./Pages/RolesPermissions/RolesPermissions";
import ConsultationType from "./Pages/Configuration/ConsultationType";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/patient" element={<Patient />} />
        <Route path="/laboratory" element={<Laboratory/>} />
        <Route path="/Billings" element={<Billings/>} />
        <Route path="/Appointments" element={<Appointments/>} />
        <Route path="/medical-records" element={<MedicalRecords/>} />
        <Route path="/department" element={<Department/>} />
        <Route path="/addPatientPage" element={<AddPatientPage/>} />
        <Route path="/doctors" element={<Doctors/>} />
        <Route path="/nurses" element={<Nurses/>} />
        <Route path="/addNurse" element={<AddNurse/>} />
        <Route path="/addDoctor" element={<AddDoctor/>} />
        <Route path="/nursing" element={<Nursing/>} />
        <Route path="/staff" element={<Staff/>} />
        <Route path="/reception" element={<Reception/>} />
        <Route path="/addStaff" element={<AddStaff/>} />
        <Route path="/roles-permissions" element={<RolesPermissions/>} />
        <Route path="/configuration/consultation-types" element={<ConsultationType/>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;